import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedInWhiteIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.9148 8.3628H13.3716V10.5828C14.0136 9.306 15.66 8.1588 18.1332 8.1588C22.8744 8.1588 24 10.7004 24 15.3636V24H19.2V16.4256C19.2 13.77 18.558 12.2724 16.9236 12.2724C14.6568 12.2724 13.7148 13.8864 13.7148 16.4244V24H8.9148V8.3628ZM0.684 23.796H5.484V8.1588H0.684V23.796ZM6.1716 3.06C6.17178 3.46233 6.09199 3.86068 5.93686 4.2319C5.78174 4.60313 5.55438 4.93982 5.268 5.2224C4.68768 5.79915 3.90217 6.12198 3.084 6.12C2.26727 6.11945 1.48357 5.79744 0.9024 5.2236C0.617054 4.94006 0.390463 4.60299 0.235612 4.23172C0.0807618 3.86045 0.000694958 3.46227 0 3.06C0 2.2476 0.324 1.47 0.9036 0.8964C1.48426 0.32179 2.26829 -0.000359053 3.0852 3.00317e-07C3.9036 3.00317e-07 4.6884 0.3228 5.268 0.8964C5.8464 1.47 6.1716 2.2476 6.1716 3.06Z",
		fill: "#0072B1"
	})]
});
const ForwardRef = forwardRef(SvgLinkedInWhiteIcon);
export { ForwardRef as ReactComponent };
